import React from "react";
import "./card/CardText";

export default function ImageCaption(props) {

  return (
    <div 
    style={{
      color: "white",
      backgroundColor: "black",
      textAlign: "center",
      overflow: "hidden",
    }}>
       {props.imageCaption.split("\r\n\r\n").map((p, i) => (
        <div
          key={i}
          style={{
            color:  "#d8e2eb",
            fontSize: props.isMobile ? "10px" : "15px",
            textAlign: "center",
            margin: "0.5vw 0.5vw",
            padding: props.isMobile? "2vw 10vw 2vw 10vw":"0vw",
            fontStyle: i===0 ? "none": "italic",
          }}
        >
        {p}
      </div>
      ))}
    </div>
  );
}
